/* eslint-disable max-len */
import digitalData from 'digital-data';

export const authorizeCardRemotePurchases = () => {
  const trackEvent = (event) => {
    digitalData.event = digitalData.event || [];
    digitalData.event.push(event);
  };

  const actions = { 
    pageLoaded: () => {
      const thdAnalyticsEvent = {
        category: {
          primaryCategory: 'overlay'
        },
        eventInfo: {
          eventName: 'authorize card for remote purchases'
        },
      };
      trackEvent(thdAnalyticsEvent);
    }, 

    buttonSubmission: ({ output }) => {
      const { section, actionType } = output || {};
      const thdAnalyticsEvent = {
        category: {
          primaryCategory: 'button submission'
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        myAccount: {
          settings: `cards and accounts: ${section}: ${actionType}`
        },
      };
      trackEvent(thdAnalyticsEvent);
    },
  };

  window.LIFE_CYCLE_EVENT_BUS.on('authorize-card-remote-purchases', actions.pageLoaded);
  window.LIFE_CYCLE_EVENT_BUS.on('authorize-card-remote-purchases.button-submission', actions.buttonSubmission);
};
